import { useEffect, useState } from "react";

const ConfigureColumnsNew = ({
    show,
    onClose,
    onSave,
    docType,
    defaultSelected = [],
    fieldsData = [],
    disabledFields = []  // ✅ new prop for non-toggleable columns
}) => {
    const [fields, setFields] = useState([]);
    const [selectedValues, setSelectedValues] = useState([]);

    useEffect(() => {
        if (fieldsData.length > 0) {
            const transformed = fieldsData.map(field => {
                const isSelected = defaultSelected.some(
                    col => col.fieldname?.toLowerCase() === field.fieldname?.toLowerCase()
                );
                const isDisabled = disabledFields.includes(field.fieldname);
                return {
                    name: field.label,
                    key: field.fieldname,
                    selected: isSelected || isDisabled,
                    disabled: isDisabled
                };
            });

            setFields(transformed);
            setSelectedValues(
                transformed
                    .filter(f => f.selected)
                    .map(f => f.key)
            );
        }
    }, [fieldsData, defaultSelected, disabledFields]);

    const toggleFieldSelection = (index) => {
        const newFields = [...fields];
        if (newFields[index].disabled) return;

        newFields[index].selected = !newFields[index].selected;
        setFields(newFields);

        const updatedSelectedValues = newFields
            .filter(f => f.selected)
            .map(f => f.key);

        setSelectedValues(updatedSelectedValues);
    };

    const handleSave = () => {
        onSave(selectedValues, fields);
        onClose();
    };

    if (!show) return null;

    return (
        <div className="position-relative">
            <div
                className="bg-white border rounded shadow-sm p-3"
                style={{
                    position: 'absolute',
                    top: '100%',
                    right: 30,
                    zIndex: 1000,
                    width: '320px'
                }}
            >
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="m-0">{docType} Fields</h6>
                    <button
                        className="btn btn-sm btn-link p-0"
                        onClick={onClose}
                    >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 4L4 12" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4 4L12 12" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>

                <div
                    className="scroll-container"
                    style={{
                        maxHeight: '300px',
                        overflowY: 'auto',
                        overflowX: 'hidden'
                    }}
                >
                    {fields.length === 0 ? (
                        <p className="text-muted">No fields found</p>
                    ) : (
                        <div className="row">
                            {fields.map((field, index) => (
                                <div key={index} className="col-12 mb-2">
                                    <div
                                        className="d-flex align-items-center px-1 py-1 hover-light"
                                        style={{
                                            cursor: field.disabled ? 'not-allowed' : 'pointer',
                                            borderRadius: '4px',
                                            opacity: field.disabled ? 0.6 : 1
                                        }}
                                        onClick={() => {
                                            if (!field.disabled) toggleFieldSelection(index);
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            className="form-check-input me-2"
                                            checked={field.selected}
                                            disabled={field.disabled}
                                            onChange={() => { }}
                                        />
                                        <span style={{ fontSize: '14px' }}>{field.name}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="d-flex justify-content-end gap-1 mt-3 pt-2 border-top">
                    <button
                        className="custom-btn-cancel d-flex"
                        onClick={() => {
                            const cleared = fields.map(f => ({
                                ...f,
                                selected: f.disabled ? true : false
                            }));
                            setFields(cleared);
                            setSelectedValues(
                                cleared.filter(f => f.selected).map(f => f.key)
                            );
                        }}
                    >
                        Clear
                    </button>
                    <button
                        className="custom-btn-00989 d-flex"
                        onClick={handleSave}
                    >
                        Apply Fields
                    </button>
                </div>

                <style>{`
                    .scroll-container::-webkit-scrollbar {
                        width: 6px;
                    }
                    .scroll-container::-webkit-scrollbar-track {
                        background: #f1f1f1;
                        border-radius: 3px;
                    }
                    .scroll-container::-webkit-scrollbar-thumb {
                        background: #FC8B5C;
                        border-radius: 3px;
                    }
                    .scroll-container::-webkit-scrollbar-thumb:hover {
                        background: #e07b00;
                    }
                    .hover-light:hover {
                        background-color: #f9fafb;
                    }
                `}</style>
            </div>
        </div>
    );
};

export default ConfigureColumnsNew;
